import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const HoneymoonTrips = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/honeymoonTrips/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/honeymoonTrips/advancedText" />

          <AdvancesCardList urlApi="services/honeymoonTrips/honeymoonTripsList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/honeymoonTrips/advancedIntro" />
    </section>
  );
};

export default HoneymoonTrips;
